import { render } from "./App.vue?vue&type=template&id=3285dbe5"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3285dbe5&lang=less"

import exportComponent from "/home/runner/work/vertex/vertex/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__